import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const AvisoLegal = () => (
  <LegalPageTemplate title="Aviso Legal" description="Aviso legal de Nubia Solar.">
    <p>Este sitio web tiene como finalidad informar sobre los servicios de instalación de placas solares y facilitar el contacto con Nubia Solar.</p>
    <h2>Titular del sitio</h2>
    <p>Nubia Solar. Contacto: info@nubiasolar.com, teléfono 604 92 17 45.</p>
    <h2>Condiciones de uso</h2>
    <p>El usuario se compromete a hacer un uso adecuado del sitio web, de sus contenidos y de los formularios disponibles. Queda prohibido el uso ilícito o lesivo de la web.</p>
    <h2>Propiedad intelectual</h2>
    <p>Los textos, imágenes, diseños, logotipos y demás elementos del sitio pertenecen a Nubia Solar o se utilizan con la debida autorización.</p>
    <h2>Responsabilidad</h2>
    <p>Nubia Solar no garantiza la ausencia absoluta de errores, aunque trabaja para mantener la información actualizada y el sitio disponible de forma continua.</p>
  </LegalPageTemplate>
);

export default AvisoLegal;
